import e from "../../hooks/useEffectOnce.js";
import t from "../../hooks/useClickOutside.js";
import "../../useClickOutside.js";
import n from "../../utils/classNames.js";
import r from "../../hooks/useMergeRefs.js";
import { useAnchorName as i } from "../../hooks/useAnchoredPopover.js";
import a, { filterOptions as ee } from "./BaseSelectDropdown.js";
import te from "./ClearButton.js";
import ne from "./SelectFilter.js";
import o from "./SelectedOption.js";
import s from "./WithFeedbackAndAddon.js";
import { useRef as c, useState as l } from "react";
import { isEmpty as u, noop as d } from "es-toolkit/compat";
import { isEqual as f } from "es-toolkit/predicate";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
//#region src/components/selects/Select.tsx
var h = -1, g = (g) => {
	let { name: _, id: v = _, label: y, options: b = [], value: x, onChange: S = d, closeOnSelect: C = !0, placeholder: re, isLoading: ie = !1, dropup: w = !1, pullRight: ae = !1, bsSize: T = "md", variant: oe = "default", disabled: E = !1, tabIndex: se = 0, hasError: ce = !1, useFilter: le = !1, useClear: ue = !1, noItemMessage: de, selectedOptionText: fe, showSelectedItemIcon: pe = !1, showUnselectedItemIcons: me = !1, dropdownClassName: he, btnClassName: D, className: O, trackingAttributes: k, inputAddon: A, errorMessage: j, warningMessage: M, messageWhiteSpace: N = "normal", ...P } = g, [F, I] = l(!1), [L, R] = l(null), [z, B] = l(!1), [V, H] = l(""), [U, W] = l(b), [G, ge] = l([]), [_e, K] = l(h), [q, J] = l(!1), ve = c(null), Y = c(null), X = i("select"), ye = { anchorName: X }, be = t(() => $()), xe = r(ve, be), Z = (e, t) => {
		t && !u(t) ? R(e.find((e) => e.id === t[0]) || null) : e && R(e.find((e) => e.selected) || null);
	};
	e(() => {
		Z(b, x);
	});
	let [Q, Se] = l(b);
	f(b, Q) || (Z(b, x), W(b), Se(b));
	let [Ce, we] = l(x);
	f(x, Ce) || (Z(b, x), we(x));
	let Te = (e = []) => {
		e.length && ((z || V) && G.length > 0 || ge(e));
	}, Ee = () => {
		R(null), B(!1), H(""), W(b), J(!1), K(h), S(void 0);
	}, De = () => {
		let e = n("dropdown-toggle", "form-control", "text-left", D && D, T === "sm" && "input-sm", T === "lg" && "input-lg", E && "disabled"), t = /* @__PURE__ */ m("button", {
			type: "button",
			id: v,
			name: _,
			className: e,
			...k,
			"data-toggle": "dropdown",
			tabIndex: se,
			"aria-haspopup": "true",
			"aria-expanded": F,
			onClick: je,
			ref: Y,
			children: [
				le && F && /* @__PURE__ */ p(ne, {
					isFilterActive: z,
					filterValue: V,
					onChange: ke
				}),
				!z && /* @__PURE__ */ p(o, {
					label: y,
					placeholder: re,
					selectedOptionText: fe,
					selectedItem: L,
					options: b,
					showSelectedItemIcon: pe,
					showUnselectedItemIcons: me
				}),
				/* @__PURE__ */ m("span", {
					className: "select-toggle-actions",
					children: [/* @__PURE__ */ p(te, {
						showClear: ue,
						selectedItem: L,
						onClear: Ee
					}), /* @__PURE__ */ p("span", { className: "caret" })]
				})
			]
		});
		return !A && !j && !M ? t : /* @__PURE__ */ p(s, {
			bsSize: T,
			inputAddon: A,
			errorMessage: j,
			warningMessage: M,
			messageWhiteSpace: N,
			children: t
		});
	}, Oe = () => {
		let e = _e;
		return q && !L && (e = 0), /* @__PURE__ */ p(a, {
			isOpen: F,
			isLoading: ie,
			options: U,
			focusedItemIndex: e,
			keyboardUsed: q,
			updateDOMValues: Te,
			onSelect: Ae,
			onClose: $,
			noItemMessage: de,
			pullRight: ae,
			dropup: w,
			dropdownClassName: he,
			anchorName: X
		});
	}, ke = (e) => {
		e.preventDefault();
		let t = e.currentTarget.value;
		if (t === "") {
			B(!1), H(""), W(b), J(!1), K(h);
			return;
		}
		let n = ee(G, t, b), r = n.length > 0 ? 0 : h;
		B(!0), H(t), W(n), J(!0), K(r);
	}, Ae = (e) => {
		R(e || null), B(!1), H(""), W(b), S(e), C && $();
	}, je = (e) => {
		if (E) return;
		if (z && U.length === 0 && e.target !== e.currentTarget.querySelector("input")) {
			B(!1), H(""), W(b), J(!1), K(h);
			return;
		}
		if (z) return;
		let t = e.detail === 0;
		I(!F), J(t);
	}, $ = () => {
		F && (I(!1), B(!1), H(""), W(b), J(!1), K(h), Y.current?.focus());
	}, Me = n("select", "dropdown", w && "dropup", F && "open", ce && "has-error", oe === "blank" && "select-blank", O && O);
	return /* @__PURE__ */ m("div", {
		...P,
		className: Me,
		ref: xe,
		style: ye,
		children: [De(), Oe()]
	});
};
//#endregion
export { g as default };

//# sourceMappingURL=Select.js.map